import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Play2LearnZoomFooterProps {
  serviceTeamUrl?: string;
}

export const Play2LearnZoomFooter: React.FC<Play2LearnZoomFooterProps> = ({ serviceTeamUrl }) => {
  const __ = useTranslation().t;

  return (
    <Container>
      <Content>
        <Title>{__('havingIssues')}</Title>
        <Description>
          <Trans alt={__('gamePinInput')} i18nKey="gamePinInput">
            Input the <strong>Game pin</strong> in the right panel and wait for the class to start.
            Have Fun!
          </Trans>
        </Description>
        <Description>
          <Trans alt={__('questionAskServiceTeam')} i18nKey="questionAskServiceTeam">
            If you have any questions, just ask our friendly{' '}
            <a target="_blank" href={serviceTeamUrl}>
              service team
            </a>{' '}
            for help. They're here for you!
          </Trans>
        </Description>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.backgroundSuperLight};
  border-top: 1px solid ${({ theme }) => theme.colors.backgroundDark};
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: '${({ theme }) => theme.fonts.primary.regular.fontFamily}';
  font-weight: bold;
  line-height: 28px;
  font-size: 18px;
`;

const Description = styled.p`
  font-family: '${({ theme }) => theme.fonts.primary.regular.fontFamily}';
  font-size: 14px;
  line-height: 18px;
`;
